import React, { type ReactElement } from 'react';

import { Banner, Spinner } from '@pushwoosh/dumb-components';
import { ArrowIcon } from '@pushwoosh/kit-icons';

import { H4 } from '~/src/ui-kit';
import { AccountsSkeleton } from '../AccountsSkeleton';
import { AccountTooltip } from '../AccountTooltip';
import { AccountBox, ListBox } from './styles';

import { SelectComponentProps } from '../../SelectAccount.types';

export function AccountsList(props: SelectComponentProps): ReactElement {
  const {
    accountsList,
    errorMessage,
    isLoading,
    isSubmitting,
    onAccountClick,
  } = props;

  return (
    <>
      <ListBox>
        {isLoading && <AccountsSkeleton />}
        {accountsList.map(({
          uid,
          name,
          allowSelect,
          methods,
          method,
        }) => (
          <AccountTooltip key={uid} isAllowSelect={allowSelect}>
            <AccountBox
              disabled={!allowSelect}
              $isSubmitting={!!isSubmitting}
              onClick={(): void => onAccountClick(uid, methods, method)}
            >
              <H4>{name}</H4>
              {isSubmitting === uid
                ? <Spinner size="small" />
                : <ArrowIcon direction="right" size="small" />}
            </AccountBox>
          </AccountTooltip>
        ))}
      </ListBox>
      {!!errorMessage && <Banner type="error" title={errorMessage} />}
    </>
  );
}
